/**
 * Indian city alias / typo normaliser.
 *
 * Production CRM data carries the long tail of:
 *   - Pre-2014 / post-2014 official renames (Bangalore → Bengaluru, etc.)
 *   - Common spelling errors customers/CSRs type ("Bengalore", "Banglore")
 *   - Whitespace artefacts ("Mumbai " with trailing space)
 *   - Casing inconsistencies ("bangalore" vs "Bangalore")
 *
 * We collapse all of those into a single canonical key so that mechanic
 * dropdowns, RBAC city filters, and any other city-based lookup match
 * regardless of how the underlying string was captured.
 *
 * Used in:
 *   - components/serviceOps/tabs/MechanicTab.jsx        (re-assign UI)
 *   - components/serviceOps/tabs/OverviewTab.jsx        (Schedule → Mechanic dropdown)
 */

const ALIASES = {
  // Bengaluru
  bangalore: "bengaluru",
  bengalore: "bengaluru",      // common typo
  banglore: "bengaluru",       // common typo
  bengalooru: "bengaluru",
  bengaluru: "bengaluru",
  blr: "bengaluru",
  // Mumbai
  bombay: "mumbai",
  mumbai: "mumbai",
  // Kolkata
  calcutta: "kolkata",
  kolkata: "kolkata",
  // Chennai
  madras: "chennai",
  chennai: "chennai",
  // Pune
  poona: "pune",
  pune: "pune",
  // Add additional aliases as data drift surfaces.
};

export function normaliseCity(raw) {
  const k = String(raw || "").trim().toLowerCase();
  return ALIASES[k] || k;
}

export function citiesMatch(a, b) {
  const na = normaliseCity(a);
  const nb = normaliseCity(b);
  return !!na && !!nb && na === nb;
}
